var _defs, _path, _polyline, _polyline2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse3, _ellipse4, _polyline3, _polygon, _polygon2, _polygon3, _polygon4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvStation19(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 146.14,
    y1: 162.29,
    x2: 199.98,
    y2: 100.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6e6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#233343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 183.35,
    y1: 250.08,
    x2: 287.65,
    y2: 130.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 62.03,
    y1: 191.1,
    x2: 83.95,
    y2: 165.97,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.24,288.6,23.74,186.65c-5.49-3.08-10.2-8.15-4.85-11.46L192,75.41c2.6-1.61,6.54-2.66,9.18-1.13L382.28,179.37c5.49,3.19,6.48,12.1,1,15.29L219,288.44A22.94,22.94,0,0,1,196.24,288.6Z",
    fill: "#d6e6f5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "201.85 132.84 137.59 170.45 118.83 159.21 184.01 116.33",
    fill: "url(#linear-gradient)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "302.29 203.79 180.37 273.17 118.83 233.99 244.06 150",
    fill: "url(#linear-gradient-2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.7,186.08c-3.55,5.84-10.58,11-15.66,15.36-7.95,6.88-17.55,14.5-28.75,12.95-6-.83-14.7-4.81-16.21-11.28-2.59-11.1,12-14.87,19.53-18.11,6.24-2.69,12.6-5.4,17.71-10a9.08,9.08,0,0,0,3.24-5,6.84,6.84,0,0,0-2.14-5.8c-4.63-4.57-12.9-2.89-17-8.19-5.75-7.52,8-13.24,15-16.32,10.11-4.42,12.66-17.39,14-34.27",
    fill: "none",
    stroke: "#233343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.41,206.16l6.71-11.31c7.35-5.74,25.51-19.26,25.51-19.26,5.25-6.6,19.71-21,19.71-21,10.28-7.56,48.67-28,51.56-28.35s12.95,1.89,14.5,2,6.25-3.06,6.25-3.06c13.94,1.15,27.57,12.58,34.08,17.53a17.53,17.53,0,0,1,6.62,12.69s.69,23.88.29,25.14-4.26,4-4.26,4,.13-13.46-9.61-8.69S287.92,197.23,287,198.11,238.51,226.49,228,232.59c.1-3-.28-6.06-2.53-8.21-2.62-2.5-6.48-2.17-9.58-.91a16.77,16.77,0,0,0-7.78,6.17c-2.8,3.45-4.15,8-4.82,12.31-.08.54-.37,8-.49,8-25.68,8.41-54.14-22.42-54.71-24.83S148.41,206.16,148.41,206.16Z",
    fill: "#76abdf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.36,206.19l6.71-11.31c7.35-5.74,25.51-19.26,25.51-19.26,5.25-6.6,19.71-21,19.71-21,10.28-7.56,48.67-28,51.56-28.35s12.95,1.89,14.5,2,6.25-3.06,6.25-3.06c13.94,1.15,27.57,12.58,34.08,17.53a17.53,17.53,0,0,1,6.62,12.69s.69,23.88.29,25.14-4.26,4-4.26,4,.13-13.46-9.61-8.69S287.88,197.26,287,198.14s-48.51,28.39-59.05,34.49c.1-3-.28-6.06-2.53-8.21-2.62-2.5-6.48-2.17-9.58-.91a16.77,16.77,0,0,0-7.78,6.17c-2.8,3.45-4.15,8-4.82,12.31-.08.54-.37,8-.49,8C177,258.41,148.57,227.59,148,225.18S148.36,206.19,148.36,206.19Z",
    fill: "#76abdf",
    opacity: 0.33
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.63,228.36c9.6,6.09,19.47,8.76,36.2,6.53-.3,1.19-1.4,5.89-1.59,7.07-.08.54-.37,8-.49,8-25.68,8.41-54.14-22.42-54.71-24.83-.52-2.23.22-16.48.34-18.69C153,216,154.13,219.17,168.63,228.36Z",
    fill: "#476786",
    opacity: 0.33
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.75,222.74s-.14,3.86-.07,3.93a53.83,53.83,0,0,0,14.87,9.05l.07-3.76S163.71,227.63,157.75,222.74Z",
    fill: "#d7fbff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.75,155.53c-2-1.91-19.8,17.89-20.92,20.56s-2.77,4.38.92,8.48,24.54,16.31,28.68,17.32,6.39,3.21,12-1.92,14.11-21.89,14.11-21.89S213.9,165.26,203.75,155.53Z",
    fill: "#f1f7fc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184,172s-3.94-3.33-6.6-2.13,3.21,5.69,3.21,5.69Z",
    fill: "#476786"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.48,
    cy: 190.5,
    rx: 16.44,
    ry: 10.99,
    transform: "translate(-2.39 377.2) rotate(-64.2)",
    fill: "#233343"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.56,
    cy: 190.57,
    rx: 8.94,
    ry: 5.98,
    transform: "translate(-1.84 378.21) rotate(-64.2)",
    fill: "#ddd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.37,232.25a4.92,4.92,0,0,1-2-1.13c-1-1.1-.31-2.53.48-3.54a5.25,5.25,0,0,1,3.07-1.87,68.2,68.2,0,0,1,7.36-1.48c1.65-.24,3.31-.44,5-.56a19.38,19.38,0,0,1,5.4.06c1.87.4,1.43,2.81.78,4.06a12.66,12.66,0,0,1-5,4.7,11.43,11.43,0,0,1-4.72,1.45,21.94,21.94,0,0,1-5.28-.41,29.11,29.11,0,0,1-3.8-.9C181.23,232.52,180.8,232.4,180.37,232.25Z",
    fill: "#f1f7fc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.41,206.16s3.11,6.1,4.94,7.65,2.71.5,2.94-1.05-.92-17.9-1.18-17.9S150.34,197.08,148.41,206.16Z",
    fill: "#f1f7fc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.94,211.3c.55.26,1.16.78,1.59,1q4.65,2.82,9.27,5.7l4.62,2.87c1,.63,3.26,1.39,2.26,2.89a19.59,19.59,0,0,1-3.85,4.05c-1,.86-1.84,1.13-3.08.4-2.26-1.32-4.52-2.62-6.77-4-1.73-1-3.71-2.31-4.25-4.4a38.91,38.91,0,0,1-1.16-6.64c-.06-.75-.19-2.31,1-2.11A1.71,1.71,0,0,1,159.94,211.3Z",
    fill: "#f1f7fc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.75,243.61a1.9,1.9,0,0,1,1.36,1.78c0,1.91-1.74,1.82-3.08,1.87-1.67.07-16.68-5-26.45-12.66s-11.45-14.15-11.45-14.15l.09-5s2.39,10.39,15.2,18a94,94,0,0,0,16.63,7.79c1.8.64,3.61,1.22,5.45,1.73A17.85,17.85,0,0,1,187.75,243.61Z",
    fill: "#f1f7fc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M287.59,149.34l10.65.66s1.53.58.63-2-11.2-13.07-24.9-16.24c0,0-19-3.28-15.47-1.93C260.49,130.6,276,137.91,287.59,149.34Z",
    fill: "#f1f7fc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M287,166.8c3.48-2.46,7-4.91,10.38-7.44a17.7,17.7,0,0,0-6.23-2,32,32,0,0,0-4,0Z",
    fill: "#f1f7fc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M263.58,164.22a65,65,0,0,0-20,15,75.43,75.43,0,0,0-13.34,22.39,1.56,1.56,0,0,0,2.27,1.89c5.95-3.71,17.73-11.09,26.22-16.55l2.13-1.37v-.15l2.38-1.7Z",
    fill: "#f1f7fc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M283.85,157.63a55.15,55.15,0,0,0-9.16,2.1c-2.15.68-4.29,1.48-6.4,2.36l-.34,18.3,14.92-10.67.76-.54Z",
    fill: "#f1f7fc"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.77,
    cy: 237.8,
    rx: 17,
    ry: 11.09,
    transform: "translate(-92.24 328.55) rotate(-64.2)",
    fill: "#233343"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.77,
    cy: 237.81,
    rx: 9.25,
    ry: 6.03,
    transform: "translate(-91.68 329.45) rotate(-64.2)",
    fill: "#ddd"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "194.47 34.13 187.09 30.68 160.52 45.93 160.52 140.55 174.95 148.58 193.32 83.16",
    fill: "#adcdec"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "174.95 84.63 174.95 148.58 201.85 132.84 201.85 68.56 174.95 84.63",
    fill: "#5e89b2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.95 84.63 167.25 49.7 194.47 34.13 201.85 68.56 174.95 84.63",
    fill: "#76abdf"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "189.18 91.16 195.73 86.87 191.53 98.93 195.73 96.48 184.89 122.14 188.57 105.88 184.89 107.52 189.18 91.16",
    fill: "#d6e6f5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "162.68 84.63 172.29 89.89 172.29 98.56 162.68 93.43 162.68 84.63",
    fill: "#76abdf"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M167.63,90.42s2.87.9,2.22,4.59c0,0-8.7,1.11-8.45,11.14,0,0-.66,1.21-4,0C157.37,106.16,156.47,93,167.63,90.42Z",
    fill: "#fffffa"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.23,52.62l5.46,23.49,17.87-10.68s-5.22-22.77-5.46-22.77S173.23,52.62,173.23,52.62Z",
    fill: "#d6e6f5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M186.47,50.92l-4.78,2.7a1.09,1.09,0,0,0-.52,1.2L184,67.1a1.09,1.09,0,0,0,1.62.69l4.6-2.75a1.09,1.09,0,0,0,.51-1.17l-2.69-12.24A1.09,1.09,0,0,0,186.47,50.92Z",
    fill: "#76abdf"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.44,61.26c-1.7,1.06-3.41,2.11-5.14,3.11l.47,2a.85.85,0,0,0,1.26.54l3.59-2.14a.85.85,0,0,0,.39-.91Z",
    fill: "#f1f7fc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M183.37,60.4l.69,3c1.74-1,3.45-2.06,5.15-3.13l-.58-2.62Q186,59.06,183.37,60.4Z",
    fill: "#f1f7fc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.21,188.49c1.48-.25,2.69-.21,3.26.46-1,10.27,6.35,5.25,9.59,7.84l2.79-1.17q8.44-8.45,17-16.81c-1.95-1.41-3.84-2.9-5.73-4.38A179.86,179.86,0,0,0,52.21,188.49Z",
    fill: "url(#linear-gradient-3)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.52,178.37V134H75.86v44.74C79.2,179.73,82.71,179.88,85.52,178.37Z",
    fill: "#a83f1e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.67,134.14v45.43a9.72,9.72,0,0,0,3.85-1.07V134.14Z",
    fill: "#7f2b14"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.13,138.17c6-.29,13.69-2.45,11.44-9.14-1.33-4-5.42-7.44-8-10.58s-2-5.24-5-8.3c2.49.1,6.1-.37,6.71-2.83.54-2.16-11.07-15.4-16.09-20.77a3.21,3.21,0,0,0-4.36-.32c-6,4.76-21.25,17.44-19.12,21.09,1.29,2.2,3.89,3,6.21,3.17-5.49,5.51-11.76,12.39-12.39,19.73-.55,6.36,6,7.21,12,6.88-4.19,5.09-15.56,19.6-13,24,1.37,2.32,5.78,3.09,8.39,3.61a83.37,83.37,0,0,0,17.2,1.66,53,53,0,0,0,17.1-2.58,24,24,0,0,0,8.34-4.59c2.67-2.51,1.18-5.18-.55-7.7C100,147.09,97.09,142.63,94.13,138.17Z",
    fill: "#76abdf"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.58,110.15s-7.31-.48-12.4-.34L106,131s.69-2.46-3.87-7.51A103.77,103.77,0,0,1,92.58,110.15Z",
    fill: "#476786"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M94.13,138.17h-15l24.5,21a3.73,3.73,0,0,0,1.08-4.84C103.08,151.51,94.13,138.17,94.13,138.17Z",
    fill: "#476786"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvStation19);
export default __webpack_public_path__ + "static/media/ev_station19.6420ab9c977fed24de3cc1a38cdfa6aa.svg";
export { ForwardRef as ReactComponent };